import { useState } from "react";
import { convertUTCtoMSK } from "../../../../../../../utils"
import { IMessageSender } from "../../core/response.types"
import { toggleEnableMessageSender } from "../../core/api";

interface Props {
  sender: IMessageSender
}

export default ({ sender }: Props) => {
    const [enabled, setEnabled] = useState(sender.enabled);
    const [loading, setLoading] = useState(false);

    const handleToggle = async () => {
        setLoading(true);

        try {
            const response = await toggleEnableMessageSender(sender.id);
            if (!response?.data?.success) {
                throw new Error(
                    'errors' in response?.data ? response?.data?.errors?.general_error : 'Unknown error'
                )
            }
            setEnabled(response.data.data.enabled);
        } finally {
            setLoading(false);
        }
    };
    

    return (<>
        <tr>
            <td>{sender.id}</td>
            <td>{sender.name}</td>
            <td>{sender.requisiteType}</td>
            <td>{sender.channel}</td>            
            <td>{convertUTCtoMSK(sender.createdAt)}</td>
            <td>
                <button
                    type="button"
                    className={`btn btn-sm ${enabled ? 'btn-light-success' : 'btn-light-danger'} min-w-90px px-2 py-1`}
                    disabled={loading}
                    onClick={handleToggle}
                >
                    {loading ? (
                        <span className="spinner-border spinner-border-sm" />
                    ) : 
                        enabled ? 'Enabled' : 'Disabled'
                    }
                </button>    
            </td>   
        </tr>
    </>)
}